// Core
import styled from 'styled-components';

// Libraries
import { Switch as SwitchAntD } from 'antd';

// Component
import { SwitchProps, SwitchWithTextSize } from './Switch.types';

export const Element = styled(SwitchAntD)`
  /*************** BACKGROUND COLOR  **************/
  background-color: ${({ theme }) => theme.color.switch.defaultUncheckedBackgroundColor};
  transition: all 0.3s ease-in-out;

  /*************** SWITCH UNCHECKED DISABLED **************/
  &.ant-switch.ant-switch-disabled {
    background-color: ${({ theme }) => theme.color.switch.defaultUncheckedBgColorDisabled};
  };
  
  /***************  SWITCH CHECKED DISABLED **************/
  &.ant-switch-checked {
    :disabled {
      background-color: ${({ theme }) => theme.color.switch.checkedBackgroundColorDisabled};
    };
  };

  &.ant-switch:not(:disabled):hover:not(.ant-switch-handle) {
    background-color: ${({ theme }) => theme.color.switch.defaultUncheckedBgColorHover};
  };

  &.ant-switch-checked:not(:disabled):hover:not(.ant-switch-handle) {
    background-color: ${({ theme }) => theme.color.switch.checkedBackgroundColorHover};
  };

  /*************** ICON  **************/
  &.ant-switch .ant-switch-handle::before {
    /*************** BACKGROUND COLOR  **************/
    background-color: ${({ theme }) => theme.color.switch.switchColorIcon};
  };
`;

export const Container = styled.div<Pick<SwitchProps, 'size'>>`
  width: max-content;
  display: flex;

  :has(p:hover) {
    .ant-switch:not(:disabled) {
      background-color: ${({ theme }) => theme.color.switch.defaultUncheckedBgColorHover};
    };

    .ant-switch-checked:not(:disabled) {
      background-color: ${({ theme }) => theme.color.switch.checkedBackgroundColorHover};
    };
  };
  
  /*************** ELEMENT  **************/
  ${Element} {
    /*************** MARGIN TOP  **************/
    margin-top: ${({ size }) => (size === SwitchWithTextSize.md ? '2px' : '5px')};
  };
`;

export const TitleContainer = styled.div<Pick<SwitchProps, 'size' | 'checked' | 'disabled'>>`
  /*************** PADDING LEFT  **************/
  padding-left: ${({ size }) => (size === SwitchWithTextSize.md ? '14px' : '10px')};
  /*************** CURSOR **************/
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
`;

export const SupportingTextContainer = styled.div<Pick<SwitchProps, 'size' | 'checked' | 'disabled'>>`
  /*************** CURSOR **************/
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
`;

export const SupportingText = styled.div<Pick<SwitchProps, 'size'>>`
  /*************** PADDING LEFT  **************/
  padding-left: ${({ size }) => (size === SwitchWithTextSize.md ? '14px' : '10px')};
`;

export const TextsContainer = styled.div`
  max-height: 52px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;
